import { Box } from "@mui/material";

import "./style.css";

const InActive = () => {
    return (
        <Box id="on-hold-area" className="auth-box" style={{ padding: "20px 0 50px 0" }}>
            <div className="container">
                <img src="/assets/images/logo.png" alt="Indi" height={"40px"} />
                <div className="auth-form">

                    <div className="description">
                        <Box>
                            <h3 style={{ marginTop: '40px', marginBottom: "20px", fontFamily: 'Josefin Sans', fontWeight: 600, fontSize: "1.50rem" }}>INACTIVE SUBSCRIPTION</h3>
                        </Box>
                        <Box>
                            <p className="indi-font-family e-text">This account is no longer active or has expired. Currently, renewing a subscription is not available through the indi app.</p>
                        </Box>

                        <Box>
                            <p className="indi-font-family e-text">If you believe this to be an error, contact support@indimoves.com</p>
                        </Box>
                    </div>

                </div>
            </div>
        </Box>
    );
};

export default InActive;
